import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800">
      <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src="/QemplateFull.png"
                alt="Qemplate Logo"
                className="h-8 w-auto"
              />
            </div>
            {/* <button
              onClick={handleBackClick}
              className="flex items-center text-gray-600 hover:text-gray-900 transition-colors group px-3 py-2 rounded-lg hover:bg-gray-100"
            >
              <ArrowLeft
                size={20}
                className="mr-1 group-hover:-translate-x-1 transition-transform"
              />
              <span className="font-medium">Back</span>
            </button> */}
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white p-8 sm:p-12 rounded-2xl shadow-lg border border-gray-200">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 border-b pb-4">
            Privacy Policy
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            Last Updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                1. Introduction
              </h2>
              <p>
                Welcome to Qemplate ("we", "our", "us"). We are committed to
                protecting your personal information and your right to privacy.
                If you have any questions or concerns about this privacy notice,
                or our practices with regards to your personal information,
                please contact us.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                2. Information We Collect
              </h2>
              <p>
                We collect personal information that you voluntarily provide to
                us when you register on the website, express an interest in
                obtaining information about us or our products and services,
                when you participate in activities on the website, or otherwise
                when you contact us. The personal information we collect may
                include the following: names, email addresses, and payment
                information (processed via Stripe).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                3. How We Use Your Information
              </h2>
              <p>
                We use personal information collected via our website for a
                variety of business purposes described below. We process your
                personal information for these purposes in reliance on our
                legitimate business interests, in order to enter into or perform
                a contract with you, with your consent, and/or for compliance
                with our legal obligations.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                4. Will Your Information Be Shared?
              </h2>
              <p>
                We only share information with your consent, to comply with
                laws, to provide you with services, to protect your rights, or
                to fulfill business obligations. We use Stripe for payment
                processing and do not store your card details on our servers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                5. How Long Do We Keep Your Information?
              </h2>
              <p>
                We will only keep your personal information for as long as it is
                necessary for the purposes set out in this privacy notice,
                unless a longer retention period is required or permitted by law
                (such as tax, accounting or other legal requirements).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">
                6. Contact Us
              </h2>
              <p>
                If you have questions or comments about this notice, you may
                contact us by email at aaron@qemplate.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
